import { useMemo } from 'react';
import { useRouteParams } from '@/context/routeParamsContext';
import { LoungeTypes } from '@/constants';
import { Lounge } from '@/types';
import { useCommonContent } from '../oneCmsIntlHooks/oneCmsIntlHelperHooks';
import useFilteredAirportLounges from './useFilteredAirportLounges';

const useFeaturedLounge = (): Lounge | null => {
  const { airportCode } = useRouteParams() as { airportCode: string };
  const {
    config: { featuredLounges },
  } = useCommonContent();
  const { filteredLounges } = useFilteredAirportLounges();

  const featuredLounge = useMemo(() => {
    const featuredExperienceType =
      (featuredLounges &&
        airportCode &&
        LoungeTypes[
          featuredLounges[airportCode] as keyof typeof LoungeTypes
        ]) ||
      LoungeTypes.CENTURION;

    return (
      filteredLounges.find(
        (lounge) => lounge.experience_type === featuredExperienceType
      ) || null
    );
  }, [filteredLounges, featuredLounges, airportCode]);

  return featuredLounge;
};

export default useFeaturedLounge;
